/**
 * API client for Playing Wallet resolution (v2).
 *
 * Calls the authenticated wallets-api endpoint to resolve the current user's
 * Playing Wallet (Biconomy smart contract wallet) address using their Privy JWT.
 */
import { isAddress } from 'ethers';
import { env } from './env';

interface PlayingWalletResponse {
  playingWalletAddress: string | null;
}

/**
 * Fetch the Playing Wallet address for the authenticated user.
 * Returns null if the user has no Playing Wallet.
 * Throws on HTTP errors so TanStack Query retries automatically.
 */
export async function fetchPlayingWallet(accessToken: string): Promise<string | null> {
  const baseUrl = env.walletsApiUrl;
  if (!baseUrl) return null;

  const response = await fetch(`${baseUrl}/playing-wallet`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  if (!response.ok) {
    throw new Error(`Playing wallet fetch failed: ${response.status}`);
  }

  const data = (await response.json()) as PlayingWalletResponse;
  const addr = data.playingWalletAddress;
  if (addr !== null && !isAddress(addr)) {
    throw new Error('Invalid playing wallet address from API');
  }
  return addr;
}
